import { CommonModule }          from '@angular/common';
import { NgModule }              from '@angular/core';
import { SwitchFilterComponent } from '@shared/list-operations/components/switch-filter/switch-filter.component';
import { UiSwitchModule }        from 'ngx-ui-switch';


@NgModule( {
	declarations: [
		SwitchFilterComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Third Party
		UiSwitchModule
	],
	exports: [
		SwitchFilterComponent
	]
} )
export class SwitchFilterModule {}
